import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useApiClient } from "../../shared/customHooks";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import { useProviderContext } from "../../components/providerComponents/context/providerContext";
import ManageUserComponent from "../../components/applicationComponents/manageUserComponent.tsx/ManageUserComponent";

export default function ManageUserPage({ type }: { type: string }) {
  const { setHeaderText, id } = type == "Provider" ? useProviderContext() : useApplicationContext();
  const api = useApiClient("UserLink", { identity: true });
  useEffect(() => {
    setHeaderText({
      value: type == "Provider" ? "Edit Provider Details" : "Edit Authorised User Details",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  const [data, setData] = useState<any>(null);
  const { userid } = useParams();

  useEffect(() => {
    api.fetchData(`GetUser`, { linkId: id, id: userid }).then((res: any) => {
      setData(res.data);
    });
  }, [userid]);

  return <>{data != null && <ManageUserComponent data={data} api={api} submitApiPath={"EditUser"} id={data?.id} />}</>;
}
